let data = null

export default function pageData() {
    if (!data) {
        const element = document.getElementById('page-data')
        data = element ? JSON.parse(element.textContent) : {}
        data.lang = data.lang || document.documentElement.lang || 'it'
    }
    return data
}
